<template>
  <div @click="checkout" class="dreambuddy2-cart-container" :class="items && items.length ? '' : 'hidden'">
    <div class="cart-icon" v-html="addToCartIcon">
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      items: null
    },
    data() {
      return {
        addToCartIcon: `<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.0881 13.2232L22.9758 5.15362C23.112 4.57098 22.6562 4.01616 22.0413 4.01616H6.35726L5.99126 2.2777C5.90006 1.84439 5.50762 1.5332 5.05237 1.5332H0.958333C0.429054 1.5332 0 1.95007 0 2.46431V3.08505C0 3.59929 0.429054 4.01616 0.958333 4.01616H3.7488L6.55384 17.3401C5.88277 17.7151 5.43056 18.4181 5.43056 19.2243C5.43056 20.4241 6.4317 21.3968 7.66667 21.3968C8.90164 21.3968 9.90278 20.4241 9.90278 19.2243C9.90278 18.6162 9.64535 18.0668 9.23099 17.6724H17.6023C17.188 18.0668 16.9306 18.6162 16.9306 19.2243C16.9306 20.4241 17.9317 21.3968 19.1667 21.3968C20.4016 21.3968 21.4028 20.4241 21.4028 19.2243C21.4028 18.3641 20.8882 17.6207 20.1418 17.2687L20.3621 16.3269C20.4984 15.7443 20.0426 15.1895 19.4276 15.1895H8.70953L8.44819 13.948H20.1536C20.6011 13.948 20.989 13.6472 21.0881 13.2232Z" fill="white"/></svg>`
      }
    },
    methods: {
      checkout() {
        window.top.postMessage({ type: 'syncCart' }, '*')
        window.top.postMessage({ type: 'checkout' }, '*')
      }
    },
    mounted() {
      window.top.postMessage({ type: 'syncCart' }, '*')
    }
  }
</script>

<style>
.dreambuddy2-cart-container {
  position: fixed;
  right: 8px;
  bottom: 8px;
  background: #2DC76D;
  background-color: #2DC76D;
  border-radius: 50px;
  width: 50px;
  height: 50px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  opacity: 1;
  transform: scale(1);
  -webkit-animation: scaling .3s ease;
  -o-animation: scaling .3s ease;
  animation: scaling .3s ease;
}
.cart-icon {
  position: absolute;
  top: 15px;
  left: 12px;
}
.cart-count {
  background: #E2260F;
  background-color: #E2260F;
  color: white;
  width: 19px;
  height: 19px;
  border-radius: 19px;
  position: absolute;
  right: 0px;
  top: -3px;
  font-size: 12px;
  text-align: center;
  padding-top: 2px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  text-overflow: ellipsis;
  overflow: hidden;
}
.hidden {
  opacity: 0;
  transform: scale(0);
  display: none;
}

@keyframes scaling {
  from {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>